module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('timeLine', {
    attrs: {
      "points": _vm.points
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-110e9c06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 8
// module chunks = 0